import i18n from '@i18next/i18n';
import { IS_SYNC_TO_B_LIST } from '@src/slide/application/service/sync-file/core/constants';

export const IS_SYNC_LIST = IS_SYNC_TO_B_LIST;

export const TOAST_FIRST_SHOW = i18n.t('这是一篇腾讯文档，是否添加到企业微信文档？');
export const TOAST_NOT_FIRST_SHOW = i18n.t('这是一篇腾讯文档，是否生成副本并添加到企业文档列表？');
export const TOAST_SUCCESS = i18n.t('添加成功，以后打开腾讯文档都默认添加。');
